/* BF Zusatzprodukte: Auswahl und Detailansicht; der Warenkorb wird von bf-product-page.liquid verwaltet. */
(()=>{'use strict';
function init(root){
  if(root.dataset.bfAddonReady==='1')return;
  root.dataset.bfAddonReady='1';
  const boxes=[...root.querySelectorAll('[data-bf-addon-check]')];
  const status=root.querySelector('[data-bf-addon-selection]');
  const update=()=>{
    const count=boxes.filter(box=>box.checked&&!box.disabled).length;
    if(status)status.textContent=count===0?'Wähle passende Extras aus.':count===1?'1 Extra ausgewählt':count+' Extras ausgewählt';
  };
  boxes.forEach(box=>box.addEventListener('change',update));
  root.querySelectorAll('[data-bf-addon-open]').forEach(button=>{
    const dialog=document.getElementById(button.getAttribute('aria-controls'));
    if(!dialog)return;
    const close=()=>{if(dialog.open)dialog.close();};
    button.addEventListener('click',()=>{if(!dialog.open)dialog.showModal();});
    dialog.querySelectorAll('[data-bf-addon-close]').forEach(el=>el.addEventListener('click',close));
    dialog.querySelectorAll('[data-bf-addon-select]').forEach(el=>el.addEventListener('click',()=>{
      const box=document.getElementById(el.dataset.addonCheckbox);
      if(box&&!box.disabled){box.checked=true;box.dispatchEvent(new Event('change',{bubbles:true}));}
      close();
    }));
    dialog.addEventListener('click',event=>{
      if(event.target!==dialog)return;
      const b=dialog.getBoundingClientRect();
      if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)close();
    });
    dialog.addEventListener('close',()=>button.focus());
  });
  update();
}
function start(){document.querySelectorAll('[data-bf-addon-root]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',start);
})();